(function () {
    'use strict';

    Directives.EmailIntegrationDirective = function EmailIntegrationDirective() {
        // @ngInject
        function EmailIntegrationDirectiveControllerCtor($scope, $injector, _, $document, $stateParams, $timeout,
                                                         UsersManager, UserService, PopupMessageService, UiPersistenceService) {
            this.constructor.$super.call(this, $scope, $injector);
            this.__objectType = 'EmailIntegrationDirectiveController';

            this.UsersManager = UsersManager;
            this.UserService = UserService;
            this.PopupMessageService = PopupMessageService;
            this.$document = $document;
            this.UiPersistenceService = UiPersistenceService;
            this._ = _;

            this.emailProvidersViewModel = [];

            this.hasGmailInegration = false;
            this.adddingGoogleIntegration = false;
            this.deleteingGoogleIntegration = false;
            this.providersListLoaded = false;
            this.integrationTypes = {
                MANDRILL: 'mandrill',
                GMAIL: 'gmail'
            };

            this.hightlightDropDown = false;
            if ($stateParams.googleIntegrationCreated) {
                $timeout(function timeout() {
                    this.hightlightDropDown = true;
                    var $element = angular.element('.email-integration');
                    // Ugly, but does the work :-\
                    var navHeight = angular.element('.first-level-navigation').height() + angular.element('.second-level-navigation').height() + 50;
                    $element.scrollParent().scrollTo(null, $element.offset().top - navHeight, 300);
                }.bind(this));
            }

            this.UsersManager.getEmailProviders(this.userModel)
                .then(function success(resp) {
                    this.buildViewModel(resp.data.providers_list, resp.data.selected_provider);
                }.bind(this))
                .catch(function fail(resp) {
                    this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, 'ACCOUNT.EMAIL_INTEGRATION.ERRORS._GETTING_AVAILABLE_EMAIL_PROVIDERS_');
                }.bind(this))
                .finally(function finallyHandler() {
                    this.providersListLoaded = true;
                }.bind(this));
        }

        var EmailIntegrationDirectiveController = Class(Controllers.BaseController, {
            constructor: EmailIntegrationDirectiveControllerCtor,
            buildViewModel: function buildViewModel(emailProvidersData, selectedProviderType) {
                this.emailProvidersViewModel.splice(0, this.emailProvidersViewModel.length);

                emailProvidersData.forEach(function iter(emailProvider) {
                    if (emailProvider.type === this.integrationTypes.GMAIL) {
                        emailProvider.onDelete = this.googleIntegrationDeleted.bind(this);
                    }

                    this.emailProvidersViewModel.push(emailProvider);
                }.bind(this));

                this.selectedProvider = this._.find(this.emailProvidersViewModel, {type: selectedProviderType});
                this.hasGmailInegration = this._.some(this.emailProvidersViewModel, {type: this.integrationTypes.GMAIL});
            },

            setEmailProvider: function setEmailProvider(item, $event) {
                if (item.deleting) {
                    return;
                }
                var providerBeforeChange = this.selectedProvider;
                this.selectedProvider = item;
                this.UsersManager.setActiveEmailProvider(this.userModel, item.type)
                    .then(function success(resp) {
                        // nothing to do here if all is well.
                    }.bind(this))
                    .catch(function fail(resp) {
                        //revert
                        this.selectedProvider = providerBeforeChange;
                    }.bind(this))
                    .finally(function finallyHandler() {
                    }.bind(this));
            },

            addGoogleEmailIntegration: function addGoogleEmailIntegration($event) {
                if (!this.adddingGoogleIntegration) {
                    this.adddingGoogleIntegration = true;
                    this.UserService.connectToAGoogleAccount(null, this.integrationTypes.GMAIL);

                    //stop the dropdown from closing
                    $event.stopPropagation();
                    $event.preventDefault();
                }
            },

            googleIntegrationDeleted: function calendarIntegrationDeleted(item, $event) {
                if (!this.deleteingGoogleIntegration) {
                    this.deleteingGoogleIntegration = true;

                    item.deleting = true;

                    this.UsersManager.deleteEmailProvider(this.userModel, this.integrationTypes.GMAIL)
                        .then(function success(resp) {
                            this.buildViewModel(resp.data.providers_list, resp.data.selected_provider);
                            this.hightlightDropDown = false; //return the state to what is was before
                        }.bind(this))
                        .catch(function fail(resp) {
                            //TODO: add some error handling here
                        }.bind(this))
                        .finally(function finallyHandler() {
                            this.deleteingGoogleIntegration = false;
                        }.bind(this));
                }
            },

            shouldShowGmailRevokedBanner: function shouldShowGmailRevokedBanner() {
                var persistence = this.UiPersistenceService.getUiPersistence(this.UiPersistenceService.keys.gmailRevoked, {});
                return this.userModel.gmail_integration_revoked_at && (!persistence[this.userModel.gmail_integration_revoked_at] || !persistence[this.userModel.gmail_integration_revoked_at].bannerDismissed);
            },

            onCloseGmailRevokedBanner: function onCloseGmailRevokedBanner($e) {
                $e.preventDefault();
                var persistence = this.UiPersistenceService.getUiPersistence(this.UiPersistenceService.keys.gmailRevoked, {});
                persistence[this.userModel.gmail_integration_revoked_at] = persistence[this.userModel.gmail_integration_revoked_at] || {};
                persistence[this.userModel.gmail_integration_revoked_at].bannerDismissed = true;
                this.UiPersistenceService.setUiPersistence(this.UiPersistenceService.keys.gmailRevoked, persistence);
            }
        });

        return {
            restrict: 'E',
            templateUrl: 'angular/app/modules/core/features/settings/account/email_integration/email_integration_template.html',
            controller: EmailIntegrationDirectiveController,
            controllerAs: 'emailIntegrationVm',
            bindToController: true,
            scope: {
                userModel: '='
            }
        };
    };

}());

